<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2020 (original work) Open Assessment Technologies SA ;
    import { __ } from '@oat-sa-private/ui-core';

    export let text = '';
    export let ariaRole = 'status';
    // different modes shows a smaller or bigger spinner with its inner text hidden
    // it's set up so there can be a smooth transition between small and large by toggling it off or on
    export let lite = false; // mainteined only for backward compatibility, use @size instead
    const sizes = {
        default: '',
        small: 'small',
        smallest: 'smallest'
    };
    export let size = '';
    $: sizeClass = sizes[size] || (lite ? sizes.small : sizes.default);
</script>

<style>
    .loading-wrapper {
        --loading-transition-duration: 0.5s;
        --indicator-size: 10rem;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        transition: width var(--loading-transition-duration), height var(--loading-transition-duration);

        &.small {
            --indicator-size: 5rem;
        }
        &.smallest {
            --indicator-size: 2rem;
        }
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    .loading {
        flex-shrink: 0;
        width: var(--indicator-size);
        height: var(--indicator-size);
        border: var(--border-fat) solid var(--color-brand-light);
        border-right-color: var(--color-brand);
        border-radius: var(--radius-circular);
        animation: 1.5s spin linear infinite;
        transition: border-width var(--loading-transition-duration);
    }
    .small .loading {
        border-width: var(--border-thick);
    }
    .smallest .loading {
        border-width: var(--border-medium);
    }

    .content {
        @add-mixin flex-center-center;
    }

    .text {
        color: var(--color-brand);
        font-size: var(--fontsize-body-s);
        font-weight: bold;
        line-height: 1.3;
        text-align: center;
        user-select: none;
        padding: var(--space-1x5);
        margin: 0 auto;
        opacity: 1;
        transform: scale(1);
        transition: opacity var(--loading-transition-duration), transform var(--loading-transition-duration);
        word-break: normal;
    }
    .small .text {
        opacity: 0;
        transform: scale(0);
    }
    .smallest .text {
        opacity: 0;
        transform: scale(0);
    }
</style>

<div class="loading-wrapper {sizeClass}" role={ariaRole} aria-live="assertive">
    <div class="loading" />
    <div class="content">
        {#if text}
            <p class="text">{text}</p>
        {:else}
            <p class="visually-hidden">{__('Content is loading')}</p>
        {/if}
    </div>
</div>
